import * as React from 'react';
import { Body2 } from '@cian/ui-kit';

import { IDeveloperCell } from '../../../../../../types/newbuildingsCompare';

export interface IDeveloperCellProps {
  cell: IDeveloperCell;
}

export const DeveloperCell = ({ cell }: IDeveloperCellProps): React.JSX.Element => (
  <Body2>{cell.data?.name ?? cell.state.text ?? ''}</Body2>
);
